import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Props as SingleStoryProps } from 'components/widgets/SingleStory/singleStory';

export const dataStories: IHashmapItemWithCustomProps<SingleStoryProps> = {
    permission: 'DataStoryRead',
    NoPermissionMessage,
    titleWithoutProjectAndContract: 'Data Story',
};
